import axios, {AxiosResponse} from 'axios';
import {StorageRequestResult} from '../backend/interfaces/storage-request';
import {PostStorageRequest} from '../backend/requests/post-storage-request';
import {BackendApiManager} from '../managers/backend-api';
import {Logger} from '../utils/managers/logger';

export class StorageRequestRepository {
  // Singleton Instance
  private static _instance: StorageRequestRepository;

  // Private
  private logger: Logger;

  static get instance(): StorageRequestRepository {
    if (!this._instance) {
      this._instance = new StorageRequestRepository();
    }
    return this._instance;
  }

  constructor() {
    // Create Logger
    this.logger = new Logger('StorageRequestRepository');
  }

  // Create a storage request
  public async create<T>(model: PostStorageRequest<T>): Promise<StorageRequestResult<T>> {
    // Storage request
    const result: AxiosResponse<StorageRequestResult<T>> = await BackendApiManager.instance.post<
      StorageRequestResult<T>
    >('/storage/request', model);

    return result.data;
  }

  // Upload to a storage request
  public async upload<T>(body: StorageRequestResult<T>, data?: any): Promise<string> {
    // Upload file
    await axios.put(body.uploadUrl as string, data, {
      headers: {
        'Content-Type': body.uploadContentTypeHeader || '',
        'Cache-Control': 'public, max-age=31536000',
      },
    });

    return body.linkingUrl as string;
  }
}
